import React from 'react';
import { BrowserRouter, useLocation } from 'react-router-dom';
import { ThemeProvider } from 'next-themes';
import { AuthProvider, useAuth } from './contexts/AuthContext';
import { MenuProvider } from './contexts/MenuContext';
import Navbar from './components/Navigation/Navbar';
import AppRoutes from './routes/AppRoutes';
import SessionMonitor from './components/SessionMonitor';

// Componente interno para manejar la lógica de autenticación
const AppContent = () => {
  const { isAuthenticated } = useAuth();
  const location = useLocation();
  
  // No mostrar Navbar en landing page, API docs, o login
  const hideNavbarRoutes = ['/', '/api-docs', '/login'];
  const shouldShowNavbar = isAuthenticated && !hideNavbarRoutes.includes(location.pathname);
  
  return (
    <div className={`App ${shouldShowNavbar ? 'with-navbar' : 'without-navbar'}`}>
      <SessionMonitor />
      {/* Mostrar Navbar solo si el usuario está autenticado y no está en rutas específicas */}
      {shouldShowNavbar && <Navbar />}
      <AppRoutes />
    </div>
  );
};

function App() {
  return (
    <BrowserRouter>
      <ThemeProvider 
        attribute="data-theme" 
        defaultTheme="light"
        enableSystem={true}
        disableTransitionOnChange={false}
      >
        <AuthProvider>
          <MenuProvider>
            <AppContent />
          </MenuProvider>
        </AuthProvider>
      </ThemeProvider>
    </BrowserRouter>
  );
}

export default App;